import loadable from "@loadable/component";
import { graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import { Grid } from "react-flexbox-grid";
// import { Grid, Row } from "react-flexbox-grid";
import Helmet from "react-helmet";
import { SwiperSlide } from "swiper/react";

import AnimatedCopy from "../components/AnimatedCopy";
import ArrowLink from "../components/ArrowLink";
import Background from "../components/Background";
// import Banner from "../components/Banner";
import BiLogo from "../images/home/bicentennial-logo-horizontal.png";
import BlueBoxImage from "../components/BlueBoxImage";
import Button from "../components/Button";
// import ButtonAbsolute from "../components/ButtonAbsolute";
import ContentParagraph from "../paragraphs/ContentParagraph";
import FullWidthFeatureParagraph from "../paragraphs/FullWidthFeatureParagraph";
// import HorizontalSubfeatureVideoParagraph from "../paragraphs/HorizontalSubfeatureVideoParagraph";
import IntroText from "../components/IntroText";
import LinksParagraph from "../paragraphs/LinksParagraph";
//import NumberedSliderParagraph from "../paragraphs/NumberedSliderParagraphVideo";
import NumberedSliderParagraphVideo from "../paragraphs/NumberedSliderParagraphVideo";
import PhotosRowParagraph from "../paragraphs/PhotosRowParagraph";
import QuoteSlider from "../components/QuoteSlider";
import SectionTitle from "../components/SectionTitle";
// import SocialMediaRow from "../components/SocialMediaRow";
import SocialMediaRowParagraph from "../paragraphs/SocialMediaRowParagraph";
import StatParagraph from "../paragraphs/StatParagraph";
// import YoutubeEmbed from "../components/YouTubeEmbed";

// const YoutubeBackground = loadable(() => import("react-youtube-background"));
const CarouselSlider = loadable(() => import("../components/CarouselSlider"));
const NewsItem = loadable(() => import("../components/NewsItem"));
const EventsItem = loadable(() => import("../components/EventsItem"));

const IndexPage = ({ data }) => {
  const [feed, setFeed] = useState([]);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const response = await fetch(
          "https://thedaily.case.edu/tag/homepage/feed/json"
        );
        const json = await response.json();
        setFeed(json.items.slice(0, 9));
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchFeed();
  }, []);

  //Youtube Player Code
  // const [player, setPlayer] = useState(null);
  // const videoOpts = {
  //   height: "600",
  //   width: "100%",
  //   playerVars: {
  //     autoplay: 1,
  //     mute: 1,
  //     loop: 1,
  //     controls: 0,
  //     playlist: "mqHAlU0IQdQ",
  //     rel: 0,
  //     showinfo: 0,
  //     modestbranding: 0,
  //   },
  // };
  // const onReady = (e) => {
  //   setPlayer(e.target);
  // };

  // Youtube play/pause button
  // const playPause = () => {
  //   var change = document.getElementById("playPause");
  //   var changeClass = document.getElementById("playPause").className;
  //   if (changeClass === "play-me") {
  //     change.className = "pause-me";
  //     change.setAttribute("aria-label", "Pause video");
  //     player.playVideo();
  //   } else {
  //     change.className = "play-me";
  //     change.setAttribute("aria-label", "Play video");
  //     player.pauseVideo();
  //   }
  // };

  // Vimeo Play/Pause button
  const playPause = () => {
    const iframe = document.getElementById("vimeoIframe");
    const button = document.getElementById("playPause");
    const placeholder = document.querySelector(".vimeo-video-placeholder");
    if (!iframe) return;
    const vimeoPlayer = iframe.contentWindow;
    if (button.className === "play-me") {
      button.className = "pause-me";
      button.setAttribute("aria-label", "Pause video");
      vimeoPlayer.postMessage('{"method":"play"}', "*");
      placeholder.style.display = "block";
    } else {
      button.className = "play-me";
      button.setAttribute("aria-label", "Play video");
      vimeoPlayer.postMessage('{"method":"pause"}', "*");
      placeholder.style.display = "block";
    }
  };

  const expandingEducationContent = data.expand_education.r.content.filter(
    (content) => content.type === "paragraph__content"
  );
  const expandingEducationImage = data.expand_education.r.content.filter(
    (content) => content.type === "paragraph__image"
  );
  const expandingEducationLinks = data.expand_education.r.content.filter(
    (content) => content.type === "paragraph__links"
  );

  return (
    <>
      <Helmet>
        <title>Case Western Reserve University: One of the nation's best</title>
        <meta
          name="description"
          content="Explore Case Western Reserve University: one of the top-ranked schools in Ohio and one of the best research universities in the U.S. Located in Cleveland, Ohio."
        />
      </Helmet>
      {/* <Banner
        href="https://go.case.edu/apply/status"
        link="Log in to make it official."
        childrenfirst="Congratulations to our admitted undergraduates! The deposit deadline is May 1. "
      ></Banner> */}
      <div class="hero-video-homepage">
        <div className="vimeo-video-container">
          <StaticImage
            src="../images/home/YTplaceholder.jpg"
            alt="Aerial photo of Case Western Reserve University's campus"
            layout="fullWidth"
            className="vimeo-video-placeholder"
          />
          <iframe
            src="https://player.vimeo.com/video/1092241403?h=9d0424018c&badge=0&autoplay=1&loop=1&muted=1&player_id=0&app_id=58479&background=1"
            width="100%"
            height="400"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Commencement 2025 Homepage Video"
            id="vimeoIframe"
          ></iframe>
          <AnimatedCopy copy="Think/Beyond the/Possible." />
        </div>
        <div class="video-btn-control">
          <button
            onClick={playPause}
            className="pause-me"
            id="playPause"
            aria-label="Pause video"
          ></button>
        </div>

        {/* Youtube Hero video */}
        {/* <div className="youtube-video-container youtube-video">
          <YoutubeBackground
            videoId="mqHAlU0IQdQ"
            className="youtube-video"
            opts={videoOpts}
            onReady={onReady}
          >
            <StaticImage
              src="../images/home/YTplaceholder.jpg"
              alt="Aerial photo of Case Western Reserve University's campus"
              layout="fullWidth"
              className="youtube-video-placeholder"
            />
            <AnimatedCopy copy="Think/Beyond the/Possible." />
          </YoutubeBackground>
        </div> */}
      </div>
      <Background color="bluebar">
        <div className="bi-bar">
          <ArrowLink href="https://case.edu/bicentennial" color="white">
            <span className="bi-link-container">
              {/* <StaticImage
                src="../images/home/bicentennial-logo-horizontal.png"
                alt="CWRU bicentennial logo"
                layout="constrained"
                className="bi-logo"
                height="30"
              /> */}
              <img
                className="bi-logo"
                src={BiLogo}
                alt={"CWRU bicentennial logo"}
              />
              <span className="bi-link">Celebrating 200 years</span>
            </span>
          </ArrowLink>
        </div>
      </Background>
      <IntroText>
        <ContentParagraph content={data.intro.r.content[0]} />
      </IntroText>
      <BlueBoxImage imageData={expandingEducationImage[0]} left>
        <SectionTitle message={data.expand_education.title} white />
        <ContentParagraph content={expandingEducationContent[0]} />
        <LinksParagraph content={expandingEducationLinks[0]} />
      </BlueBoxImage>
      <Grid className="rotating-carousel">
        <SectionTitle message={data.cwru_difference.title} />
        <div className="mv2">
          <CarouselSlider nopad>
            {data.cwru_difference.r.content.map((paragraph, i) => {
              return (
                <SwiperSlide key={i}>
                  <StatParagraph content={paragraph} />
                </SwiperSlide>
              );
            })}
          </CarouselSlider>
        </div>
      </Grid>
      <Background color="light">
        <SectionTitle message={data.research_innovation.title} />
        <NumberedSliderParagraphVideo
          content={data.research_innovation.r.content}
        />
      </Background>
      <FullWidthFeatureParagraph
        title={data.cleveland.title}
        content={data.cleveland.r.content[0]}
      />
      <Grid fluid className="photo-grid">
        <div className="photo-section">
          <SectionTitle message={data.cwru_photorow.title} />
          <PhotosRowParagraph content={data.cwru_photorow.r.content[0]} />
        </div>
      </Grid>
      <QuoteSlider
        title={data.student_spotlight.title}
        content={data.student_spotlight.r.content}
      />
      {feed && (
        <Background color="light" containerClass="rotating-carousel">
          <SectionTitle message="News and Updates" />
          <CarouselSlider>
            {feed.map((story, index) => (
              <SwiperSlide key={index}>
                <NewsItem story={story} index={index} key={index} />
              </SwiperSlide>
            ))}
          </CarouselSlider>
          <div className="text-right mb4">
            <Button
              to="https://thedaily.case.edu/tag/homepage/"
              target="_blank"
            >
              See All News
            </Button>
          </div>
        </Background>
      )}
      <Background color="white">
        <div className="upcoming-events-section">
          <SectionTitle message="Upcoming Events" />
          <div className="events-container">
            {data.events.edges.map((story, index) => (
              <EventsItem story={story.node} index={index} key={index} />
            ))}
          </div>
          <div className="text-right mb4">
            <Button
              to="https://community.case.edu/events?topic_tags=15171519"
              target="_blank"
            >
              See More Events
            </Button>
          </div>
        </div>
      </Background>
      <Grid fluid className="social-grid">
        <div className="social-section">
          <SocialMediaRowParagraph
            content={data.cwru_socialmediarow.r.content[0]}
          />
        </div>
      </Grid>
    </>
  );
};

export const pageQuery = graphql`
  {
    intro: nodeRobust3ColumnPage(title: { eq: "Home page intro text" }) {
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphContent
        }
      }
    }
    expand_education: nodeRobust3ColumnPage(
      title: { eq: "Expand Your Education" }
    ) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          type: __typename
          ...ParagraphContent
          ...ParagraphImage
          ...ParagraphLinks
        }
      }
    }
    cwru_difference: nodeRobust3ColumnPage(
      title: { eq: "The CWRU Difference" }
    ) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphStat
        }
      }
    }
    research_innovation: nodeRobust3ColumnPage(
      title: { eq: "Research and Innovation" }
    ) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphNumberedSliderVideo
        }
      }
    }
    cleveland: nodeRobust3ColumnPage(
      title: { eq: "Find Yourself in Cleveland" }
    ) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphFullWidthFeature
        }
      }
    }
    student_spotlight: nodeRobust3ColumnPage(
      title: { eq: "Student Spotlight" }
    ) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          type: __typename
          ...ParagraphContent
          ...ParagraphQuote
        }
      }
    }
    cwru_photorow: nodeRobust3ColumnPage(title: { eq: "More to Explore" }) {
      title
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphPhotosRow
        }
      }
    }
    events: allFeedHomeEventsFeed(limit: 4) {
      edges {
        node {
          title
          link
          content
          eventDate
          eventEndTime
          end
          eventTime
          eventStartDateTime
          eventEndDateTime
          start
        }
      }
    }
    cwru_socialmediarow: nodeRobust3ColumnPage(
      title: { eq: "Homepage Social Media Row" }
    ) {
      r: relationships {
        content: field_robust_3_page_ref {
          ...ParagraphSocialMediaRow
        }
      }
    }
  }
`;

export default IndexPage;
